import React, { useContext, useEffect, useState } from 'react';
import Context from '../../../../context/context';
import { getDate, getHour, getFormatHour } from '../../../../common/utils';
import { travelTypeEnum } from '../../../../common/enum';
import NumOfPayment from '../../../numOfPayment/numOfPayment';
import CurrencyType from '../../../currencyType/currencyType';
import { fetchDollarValue , fetchTermsValue} from '../../../../apiCall';
import './index.scss';

const Summary = (props) =>{

    const {state} = useContext(Context);
    const [date, setDate] = useState();
    const [hour, setHour] = useState();
    const [hourBack, setHourBack ] = useState();
    const [inviteDate, setInviteDate] = useState();
    const [inviteBack, setInviteBack] = useState();
    const [dollarValue, setDollarValue] = useState(0);
    const [termsValue, setTermsValue] = useState('');
    const price = props.price;

    useEffect(() =>{
        getDollarValue()
        getTermsValue()
        console.log(state)
        setDate(getDate(date));
        if(state.tripType === travelTypeEnum.private){
            setHour(getHour(state.hour))
        } else {
            setHour(getFormatHour(state.selectedOrbit.hour + ':' + state.selectedOrbit.minutes))
        }
        if(state.tripType == travelTypeEnum.private && state.side === 'מאומן'){
            setHourBack(getHour(state.hourBack))
        }
        

        initInviteBack();
        if(state.side == 'מאומן'){
         setInviteDate(getDate(state.dateBack))  
          setHourBack(getHour(state.hourBack)) 
        }else{
            setInviteDate(getDate(state.date))   
        }
        
    }, [])

   const initInviteBack=()=>{
        let orbitBack = state.selectedOrbitBack;
        let dateBack = state.dateBack;
        let hourBack = state.hourBack;
        if(state.tripType === travelTypeEnum.private){
            hourBack = state.hourBack
        } else {
            hourBack = orbitBack.hour + ':' + orbitBack.minutes
        }
        if(orbitBack && dateBack && hourBack){
            setInviteBack({orbitBack, dateBack: getDate(dateBack), hourBack: getHour(hourBack)})
        }
    }

    const getDollarValue = () => {
        fetchDollarValue(function(response) {
            setDollarValue(response.data.value)
          if (!response.result || response == null) {
          } else {
          }
        });
      };

    const getTermsValue = () => {
        fetchTermsValue(function(response) {
            setTermsValue(response.data.termsOfUse)
          if (!response.result || response == null) {
          } else {
          }
        });
      };

      
    const handleBackButtonClick = () => {
        // if (props.isMobile) {
        //   props.setActiveStep(2);
        // } else {
        // props.handleSummaryButtonClick();
        // // props.setActiveStep(8); 
        // props.setActiveStep(2);
        //    }
        props.setActiveStep(2);
      };

    return (
        <div className='card summaryCard' style={{marginLeft:'-10px'}}>
                <h3>סיכום הזמנה</h3>
                <div className='parameter'>
                    <span>{state.tripType}</span>
                    <span style={{color: state.tripType === undefined ? 'red' : 'inherit' ,  fontWeight: 'bold' }}>  :  סוג נסיעה  </span>
                    </div>
{/*                     
                {state.tripType === travelTypeEnum.private ? <><h6>:נקודות עצירה</h6>
                    {state.tripStops.length > 0 ? <div> טיול: {state.tripStops.map((trip, index) => { return <span key={trip.id}>{trip.city}{index !== state.tripStops.length - 1 ? <span> , </span> : <></>}</span> }
                    )}</div> : <></>}
                    {state.saturdayStops.length > 0 ? <div> שבת: {state.saturdayStops.map((trip, index) => { return <span key={trip.id}>{trip.city}{index !== state.tripStops.length - 1 ? <span> , </span> : <></>}</span> }
                    )}</div> : <></>}
                    {state.sleepStops.length > 0 ? <div> לינה: {state.sleepStops.map((trip, index) => { return <span key={trip.id}>{trip.city}{index !== state.tripStops.length - 1 ? <span> , </span> : <></>}</span> }
                    )}</div> : <></>}</> : <></>} */}
                <div>
                    {state.side === 'מאומן' ? <>
                    <h6 className="headerBack" style={{textAlign:'center'}}>: נסיעת חזור</h6>
                    </> : <>
                    <h6 className="headerBack" style={{textAlign:'center'}}>: נסיעת הלוך</h6>
                    </>}
                    {state.tripType === travelTypeEnum.private ? <>
                    <div className='parameter'>
                    <span>{state.carType.carTypeHebrew}</span>
                    <span  style={{ color: state.carType === '' ? 'red' : 'inherit'   , fontWeight: 'bold'}} >  : סוג רכב  </span>
                    </div></> : <></>}
                    <div className='parameter'>
                    {state.side === 'מאומן' ? <>
                    <span> {inviteDate} </span>
                    </> : <>
                    <span> {inviteDate} </span>
                    </>}
                    <span style={{ color: inviteDate === '' ? 'red' : 'inherit', fontWeight: 'bold' }}>  : תאריך  </span>
                    </div>
                    <div className='parameter'>
                    {state.tripType == travelTypeEnum.private && state.side == 'מאומן' ? getHour(hourBack) : <span>{hour}</span>}
                    <span style={{ fontWeight: 'bold' }}>  : שעה  </span>
                    </div>
                    <div className='parameter'>
                    <span>{state.selectedOrbit.name}</span>
                    <span style={{color: state.selectedOrbit.name === undefined ? 'red' : 'inherit' ,  fontWeight: 'bold' }}>  : מסלול  </span>
                    </div>
                    <div className='parameter'>
                    <span>{state.flightNumber}</span>
                    <span style={{color: state.selectedOrbit.name === undefined ? 'red' : 'inherit' ,  fontWeight: 'bold' }}>  : מספר טיסה  </span>
                    </div>
                    {/* {state.startLocation.hebrewAdressn !== '' ? <>
                      <div className='parameter'>
                    <span>{state.startLocation.hebrewAdress}</span>
                    <span style={{color: state.startLocation.hebrewAdress === undefined ? 'red' : 'inherit' ,  fontWeight: 'bold' }}>  : נקודת איסוף  </span>
                    </div>
                    </> : <></>} */}
                    <h6 className="headerBack" style={{textAlign:'center'}}>:פרטי נוסע</h6>
                    <div className='parameter'>
                    <span>{state.name}</span>
                    <span style={{ fontWeight: 'bold' }}>  : שם  </span>
                    </div>
                    {/* <div className='parameter'>
                    <span>{state.englishName}</span>
                    <span style={{ fontWeight: 'bold' }}>  : שם באנגלית  </span>
                    </div> */}
                    <div className='parameter'>
                    <span>{state.amount}</span>
                    <span style={{ fontWeight: 'bold' }}> :  כמות  </span>
                    </div>
                    <div className='parameter'>
                    <span>{state.countryCode}</span><span>{state.phone}</span>
                    <span style={{ fontWeight: 'bold' }}>  : טלפון  </span>
                    </div>
                    <div className='parameter'>
                    <span>{state.secondCountryCode}</span><span>{state.anotherPhone}</span>
                    <span style={{ fontWeight: 'bold' }}> :  טלפון נוסף  </span>
                    </div>
                    {state.notes ? 
                    <div className='parameter'>
                    <span>{state.notes}</span>
                    <span style={{ fontWeight: 'bold' }}>  : הערות  </span>
                    </div>
                    : <></>}
                    {state.tripType === travelTypeEnum.sadir ? 
                    <div className='parameter'>
                    <span>{state.price}$</span>
                    <span style={{ fontWeight: 'bold'}}>  : מחיר   </span>
                    </div>
                    :
                    <div className='parameter'>
                    <span>{state.price}$</span>
                    <span style={{ fontWeight: 'bold'}}>  : מחיר   </span>
                    </div>
                    }
                    

                </div>
                {/* {!inviteBack  ? 
                <>
                <div style={{border : '0.5px solid black' , padding:'10px' , borderRadius : '5px'}}>
                <p className="headerBack" style={{textAlign:'center'}}
                > 
                ...אופס
                 </p>
                <p className="headerBack" style={{ textAlign:'center'}}>ראינו ששכחת להזמין הסעה לטיסה חזור</p>
                <button 
                className='backBtnMobile'
                style={{backgroundColor:'#f8b22c'}}
                  onClick={handleBackButtonClick}
                > !הזמן נסיעת חזור עכשיו </button>
                </div>
                </>:<></>} */}
                {inviteBack?
                <div className="inviteBackDiv">
                    <span className="headerBack">נסיעת חזור</span>
                    <div className='parameter'>
                        <span>{inviteBack.dateBack}</span>
                        <span style={{fontWeight: 'bold' }}>  : תאריך  </span>
                    </div>
                    <div className='parameter'>
                        <span>{inviteBack.hourBack || state.hourBack}</span>
                        <span style={{ fontWeight: 'bold' }}>  : שעה  </span>
                    </div>
                    <div className='parameter'>
                        <span>{inviteBack.orbitBack.name}</span>
                        <span style={{ fontWeight: 'bold' }}>  : מסלול  </span>
                    </div>
                     {state.tripType === travelTypeEnum.private ? <>
                    <div className='parameter'>
                    <span>{state.carBackType.carTypeHebrew}</span>
                    <span  style={{ color: state.carBackType === '' ? 'red' : 'inherit'   , fontWeight: 'bold'}} >  : סוג רכב  </span>
                    </div></> : <></>}
                    <div className='parameter'>
                        <span>{state.flightNumberBack}</span>
                        <span style={{ fontWeight: 'bold' }}>  : מספר טיסה  </span>
                    </div>
                    <div className='parameter'>
                        <span>{state.priceBack}$</span>
                        <span style={{ fontWeight: 'bold' }}>  : מחיר  </span>
                    </div>

                </div>
                : <></>}
                 <div>
                 <span style={{ fontWeight: 'bold' , fontSize:'20px'}}>  :  (לאחר עמלת אשראי)סה"כ לתשלום  </span>
                 <br></br>
                    <span style={{ fontWeight: 'bold' , fontSize:'20px' }}>{(state.pricePercent + state.priceBackPercent + 0.45).toFixed(2)}$</span>
                    <br></br>
                    <span style={{ fontWeight: 'bold' , fontSize:'20px' }}>{((state.pricePercent + state.priceBackPercent ) * dollarValue + 1.5).toFixed(2)}₪</span>
                    </div>
                    <CurrencyType></CurrencyType>
                    <NumOfPayment></NumOfPayment>
                    
            </div>
    )
}

export default Summary;